export default {
    top_menu: [
        {name:'Home',    id:0},
        {name:'Show Business', id:1},
        {name:'Cooking',  id:2},
        {name:'Politics',   id:3},
        {name:'Piquant',  id:4},
        {name:'Society',   id:5},
        {name:'Health',   id:6},
    ],
    read_other: 'Read other',
    read_more:  'Read more',
    not_found:  'Not found',
    read_also:  'Read also',
    copy_rights: 'Copyright © 2019 «mixer-novostei.ru». All rights reserved.',
    subscribe: 'Subscribe',

    thank_order: 'THANK YOU FOR THE ORDER',
    specialist_contact: 'Our specialist will contact you soon, expect our call',
    attention: 'Attention',
    we_value_customers: 'We value each of our customers, so we also want to offer you special products with a special price just for you.',
    hurry: 'Hurry, the activation time of the discount is limited! You have only <span id="time" class="time">30:00</span> minutes to choose one of these unique products:',

    hour_ago1: "hour ago",
    hour_ago2: "hour ago",
    hour_ago3: "hour ago",
    new_publications: "New posts",
    read: "Read",
    today_at: "Today in",
    author_names: ['Elena Klimova','Mariia Andreeva','Irina Klimenko'],
    main_news: "Top news",
    leave_already: "Leaving already? Wait for the news we’ve updated",
    already_shared: "already shared"

}